import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Popup } from "devextreme-react";
import FormConfig from "./formConfig";
import FormIngreso from "./formIngreso";
import FormMatriz from "./formMatriz";
import { setHideShowWizard, setStepWizard, resetOpeningState } from "../actions";
import { ModalTitleSteps } from "../../../../../Shared/ModalTitleSteps";

class ModalWizardOpening extends React.PureComponent {
  getStep = () => {
    const currentSteps = { ...this.props.steps };
    if (currentSteps.stepOne === true) return 1;
    if (currentSteps.stepTwo === true) return 2;
    if (currentSteps.stepThree === true) return 3;
  }

  handleClose = () => {
    this.props.dispatch(setStepWizard({
      isNewApertura: true,
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepSuccess: false,
    }));
    this.props.dispatch(setHideShowWizard(false));
    this.props.dispatch(resetOpeningState(this.props.centerId));
  }

  render() {
    return (
      <Popup
        visible={this.props.isPopupWizardOpen}
        showTitle
        width={700}
        height={550}
        onHiding={this.handleClose}
        showCloseButton
        dragEnabled={false}
        titleTemplate={(element) => {
          ReactDOM.render(
            <ModalTitleSteps
              title={this.props.steps.isNewApertura ? "Nueva Apertura" : "Editar Apertura"}
              currentStep={this.getStep()}
              totalSteps={3}
              onClose={this.handleClose}
            />
            , element
          );
        }}
      >
        <div>
          {this.props.steps.stepOne && this.props.isPopupWizardOpen && <FormConfig />}
          {this.props.steps.stepTwo && <FormIngreso />}
          {this.props.steps.stepThree && <FormMatriz />}

        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => ({
  isPopupWizardOpen: state.aperturasSel.isPopupWizardOpen,
  Opening: state.aperturasSel.Opening,
  steps: state.aperturasSel.steps,
  centerId: state.aperturasSel.centerId
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalWizardOpening);
